import { useMutation } from "react-query";
import { calculateDailyRiskScoresService } from "./riskScoringService";

export const useCalculateDailyRiskScoresMutation = () =>
  useMutation(calculateDailyRiskScoresService);